import { useEffect, useState } from "react";
import { QUERY_CALENDAR_LIST } from "services/graphQL/queries";
import { useCIQQuery } from "./ciq-gql-hooks";
import {
  EMPTY_CALENDAR_OFFS,
  parseCalendarOffsFromQueryData
} from "./parse-calendar-offs";

export { EMPTY_CALENDAR_OFFS, parseCalendarOffsFromQueryData };
export type { CalendarListQueryData } from "./parse-calendar-offs";

export const useGetProjectCalendarHolidaysAndWeekends = (
  projectId: string,
  gqlClientForProject: any
) => {
  const [calendarOffs, setCalendarOffs] = useState(EMPTY_CALENDAR_OFFS);

  const { data: calHolidayData, refetch } = useCIQQuery(QUERY_CALENDAR_LIST, {
    client: gqlClientForProject,
    variables: { projectId },
    skip: !gqlClientForProject
  });

  useEffect(() => {
    setCalendarOffs(parseCalendarOffsFromQueryData(calHolidayData));
  }, [calHolidayData]);

  return { calendarOffs, refetch };
};
